export default __webpack_public_path__ + "static/media/034-baggage.892d130e.svg";